import Box from '@mui/material/Box';
import { useId } from 'react';

import { adjustLightAndSat } from '@erikdakoda/ui/shared/colorUtils';
import { Shader, Halftone, SolidColor, Swirl } from 'shaders/react';

import { shaderIdPrefix } from '../utils/shaderIdPrefix';

type Props = {
  color?: string;
};

export default function BackHalftoneFlowing({ color }: Props) {
  'use memo';

  const highlight = color || '#002F9A';
  const background = adjustLightAndSat(highlight, 0.15, 1);
  const uid = shaderIdPrefix(useId());

  return (
    <Box
      className="back-halftone-flowing"
      sx={{
        backgroundColor: background,
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
      }}
    >
      <Shader style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}>
        <SolidColor id={`${uid}_solid`} color="#00000000" visible={true} />
        <Halftone id={`${uid}_halftone`}>
          <Swirl id={`${uid}_swirl`} colorA="#002F9A" colorB="#3d0b59" />
        </Halftone>
      </Shader>
    </Box>
  );
}
